import React, { useState } from 'react';
import bibleService from '../services/bibleService';
import { BIBLE_TRANSLATIONS } from '../data/bibleData';

function Search({ onVerseSelect, currentTranslation = 'KJV' }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTranslation, setSearchTranslation] = useState(currentTranslation);

  const handleSearch = async () => {
    if (!query.trim()) return;

    setLoading(true);
    try {
      const searchResults = await bibleService.searchVerses(query, searchTranslation);
      setResults(searchResults);
      setIsOpen(true);
    } catch (error) {
      console.error('Search error:', error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleVerseClick = (verse) => {
    onVerseSelect(verse);
    setIsOpen(false);
    setQuery('');
    setResults([]);
  };

  return (
    <div className="search-container">
      <div className="form-group">
        <label>Search Translation:</label>
        <select
          value={searchTranslation}
          onChange={(e) => setSearchTranslation(e.target.value)}
        >
          {BIBLE_TRANSLATIONS.map(translation => (
            <option key={translation.code} value={translation.code}>
              {translation.name}
            </option>
          ))}
        </select>
      </div>
      <div className="search-bar-container">
        <input
          type="text"
          className="search-bar"
          placeholder="Search Bible verses..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <button
          className="btn btn-primary"
          onClick={handleSearch}
          disabled={loading || !query.trim()}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </div>

      {isOpen && (
        <div className="search-results-modal">
          <div className="search-results">
            <div className="search-header">
              <h3>Search Results</h3>
              <button
                className="close-btn"
                onClick={() => setIsOpen(false)}
              >
                ×
              </button>
            </div>
            {results.length === 0 ? (
              <p>No results found.</p>
            ) : (
              results.map((result, index) => (
                <div
                  key={index}
                  className="search-result-item"
                  onClick={() => handleVerseClick(result)}
                >
                  <div className="result-reference">{result.reference}</div>
                  <div className="result-text">{result.text}</div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Search;